import gatewayService from '../service/gateway'
const state = {
    query: {
        macAddress: "",
        customer: "",
        type: "",
        version:"",
        page: 1,
        pageSize: 10,
    },
    searchResult: {
        total: 0,
        gateways: [],
    },
    loading: false,
}

const actions = {
    updateGateway({ commit }, gateway) {
        return gatewayService.updateGateway(gateway).then(data => {
            commit('setGateway', gateway);
            return data;
        })
    },
    newCertGateway({ commit }, id) {
        commit('setLoading', true)
        return gatewayService.newCertGateway(id).then((cert) => {
            commit('setLoading', false)
            return cert;
        })
    },
    createGateway({ commit }, gateway) {
        return gatewayService.createGateway(gateway).then(data => {
            gateway._id = data._id;
            commit('addGateway', gateway);
            return data;
        })
    },
    deleteGateway({ commit }, id) {
        return gatewayService.deleteGateway(id).then(() => {
            commit('removeGateway', id);
            return id;
        })
    },
    getGateways({ commit }, query) {
        commit('setLoading', true)
        return gatewayService.getGateways(query).then(gateways => {
            commit('setGateways', gateways);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
    addGateway(state, gateway) {
        state.searchResult.gateways.push(gateway)
        state.searchResult.total++;
    },
    removeGateway(state, id) {
        var index = state.searchResult.gateways.findIndex(x => x._id == id)
        if (index) {
            state.searchResult.gateways.splice(index, 1)
        }
    },
    setGateway(state, gateway) {
        let index = state.searchResult.gateways.findIndex(x => x._id == gateway._id)
        if (index != -1) {
            state.searchResult.gateways[index].customer = gateway.customer
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setGateways(state, gateways) {
        state.searchResult = gateways
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



